<svg #svg class="stage-svg" [attr.viewBox]="'0 0 ' + VIEW_W + ' ' + VIEW_H"
     preserveAspectRatio="xMidYMid meet"
     (pointermove)="onMove($event)"
     (pointerup)="onUp($event)"
     (pointercancel)="onUp($event)"
     (pointerleave)="onUp($event)">

  <defs>
    <linearGradient id="cf-panel" x1="0" y1="0" x2="0.4" y2="1">
      <stop offset="0%" stop-color="#123246" /><stop offset="60%" stop-color="#0a2233" /><stop offset="100%" stop-color="#051320" />
    </linearGradient>
    <radialGradient id="cf-ambient" cx="50%" cy="50%" r="60%">
      <stop offset="0%" stop-color="rgba(70,190,230,0.28)" /><stop offset="100%" stop-color="rgba(70,190,230,0)" />
    </radialGradient>
    <linearGradient id="cf-water" x1="0" y1="0" x2="0.2" y2="1">
      <stop offset="0%" stop-color="#8ce8ff" /><stop offset="45%" stop-color="#3fb4ec" /><stop offset="100%" stop-color="#1774b6" />
    </linearGradient>
    <linearGradient id="cf-water-side" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#2a92c8" /><stop offset="100%" stop-color="#125688" />
    </linearGradient>
    <linearGradient id="cf-sheen" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="rgba(255,255,255,0.32)" /><stop offset="30%" stop-color="rgba(255,255,255,0.04)" /><stop offset="100%" stop-color="rgba(255,255,255,0)" />
    </linearGradient>
    <clipPath id="cf-front-clip"><polygon [attr.points]="frontFace" /></clipPath>
    <filter id="cf-glow" x="-60%" y="-60%" width="220%" height="220%">
      <feGaussianBlur stdDeviation="4" result="b" /><feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
    </filter>
    <filter id="cf-soft" x="-60%" y="-60%" width="220%" height="220%"><feGaussianBlur stdDeviation="12" /></filter>
    <!-- underwater caustic light texture -->
    <filter id="cf-caustic" x="0" y="0" width="100%" height="100%">
      <feTurbulence type="fractalNoise" baseFrequency="0.013 0.021" numOctaves="2" seed="7" result="n" />
      <feColorMatrix in="n" type="matrix" values="0 0 0 0 0.45  0 0 0 0 0.82  0 0 0 0 1  0 0 0 0.6 -0.34" />
    </filter>
    <linearGradient id="cf-ray" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="rgba(185,236,255,0.5)" /><stop offset="100%" stop-color="rgba(185,236,255,0)" />
    </linearGradient>
    <!-- gauge glass + glowing liquid -->
    <linearGradient id="cf-gtube" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0%" stop-color="rgba(255,255,255,0.20)" /><stop offset="20%" stop-color="rgba(255,255,255,0.04)" />
      <stop offset="80%" stop-color="rgba(120,180,220,0.05)" /><stop offset="100%" stop-color="rgba(120,180,220,0.16)" />
    </linearGradient>
    <linearGradient id="cf-gliq" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#8ff4ff" /><stop offset="55%" stop-color="#33b8ee" /><stop offset="100%" stop-color="#1a82cf" />
    </linearGradient>
    <radialGradient id="cf-orb" cx="38%" cy="32%" r="72%">
      <stop offset="0%" stop-color="#ffffff" /><stop offset="45%" stop-color="#7fe6ff" /><stop offset="100%" stop-color="#1f95d6" />
    </radialGradient>
    <clipPath id="cf-gtube-clip"><rect [attr.x]="GX" [attr.y]="GY_TOP - 14" [attr.width]="GW" [attr.height]="(GY_BOT - GY_TOP) + 28" [attr.rx]="GW / 2" /></clipPath>
    <clipPath id="cf-gliq-clip"><rect [attr.x]="GX" [attr.y]="gaugeLevelY" [attr.width]="GW" [attr.height]="GY_BOT - gaugeLevelY" /></clipPath>
  </defs>

  <!-- Panel (full-bleed) -->
  <rect x="0" y="0" [attr.width]="VIEW_W" [attr.height]="VIEW_H" fill="url(#cf-panel)" />

  <!-- ── Underwater ambience ──────────────────────────────────────── -->
  <rect class="caustic" x="0" y="0" [attr.width]="VIEW_W" [attr.height]="VIEW_H" filter="url(#cf-caustic)" />
  <g class="scene-bubbles">
    <circle cx="120" cy="560" r="5" /><circle cx="250" cy="560" r="3" /><circle cx="410" cy="560" r="6" />
    <circle cx="700" cy="560" r="4" /><circle cx="820" cy="560" r="3" /><circle cx="930" cy="560" r="5" />
    <circle cx="560" cy="560" r="3.5" /><circle cx="180" cy="560" r="4" /><circle cx="760" cy="560" r="6" />
  </g>
  <g class="particles" fill="#bfe9ff">
    <circle cx="160" cy="140" r="2" /><circle cx="470" cy="90" r="1.5" /><circle cx="300" cy="230" r="1.6" />
    <circle cx="560" cy="180" r="2" /><circle cx="220" cy="330" r="1.5" /><circle cx="620" cy="300" r="1.8" />
    <circle cx="380" cy="410" r="1.4" /><circle cx="700" cy="420" r="1.6" />
  </g>
  <!-- ── Fish tank ─────────────────────────────────────────────────── -->
  <!-- contact shadow -->
  <ellipse class="tank-shadow" [attr.cx]="shadowCX" [attr.cy]="shadowCY" [attr.rx]="shadowRX" ry="20" filter="url(#cf-soft)" />

  <!-- see-through back edges -->
  <g class="back-edges">
    <line *ngFor="let s of hiddenEdges" [attr.x1]="s.x1" [attr.y1]="s.y1" [attr.x2]="s.x2" [attr.y2]="s.y2" />
  </g>

  <!-- water (inside the glass) -->
  <g *ngIf="hasWater">
    <polygon [attr.points]="waterRight" class="water-side" />
    <polygon [attr.points]="waterFront" class="water-front" />
    <polygon [attr.points]="waterTop" class="water-top" />
    <line class="water-brim" [attr.x1]="waterSurfaceEdge.x1" [attr.y1]="waterSurfaceEdge.y1"
          [attr.x2]="waterSurfaceEdge.x2" [attr.y2]="waterSurfaceEdge.y2" />
  </g>

  <!-- rising bubbles (whenever there's water) -->
  <g *ngIf="hasWater">
    <circle *ngFor="let b of bubbles" class="bubble" [attr.cx]="b.x" [attr.cy]="b.y" [attr.r]="b.r"
            [style.--rise]="(tankH * 0.72) + 'px'"
            [style.animation-delay.ms]="b.delay" [style.animation-duration.ms]="b.dur" />
  </g>

  <!-- fish on a perfect fill -->
  <text *ngIf="solvedState" class="fish" [attr.x]="tankCenter.x" [attr.y]="tankCenter.y"
        text-anchor="middle" dominant-baseline="central">🐠</text>

  <!-- glass faces (shaded) -->
  <polygon [attr.points]="topFace" class="glass glass-top" />
  <polygon [attr.points]="rightFace" class="glass glass-right" />
  <polygon [attr.points]="frontFace" class="glass glass-front" />
  <!-- front sheen -->
  <polygon [attr.points]="frontFace" class="sheen" fill="url(#cf-sheen)" />

  <!-- unit-cube grid -->
  <line *ngFor="let s of gridLines" class="cube-grid"
        [attr.x1]="s.x1" [attr.y1]="s.y1" [attr.x2]="s.x2" [attr.y2]="s.y2" />

  <!-- crisp edges -->
  <polygon [attr.points]="topFace" class="edge" />
  <polygon [attr.points]="rightFace" class="edge" />
  <polygon [attr.points]="frontFace" class="edge" [class.win]="solvedState" />

  <!-- shortfall: dashed brim line showing how high it should reach -->
  <polygon *ngIf="shortfall" [attr.points]="frontFace" class="short-brim" />
  <!-- overflow: red wash on the opening -->
  <polygon *ngIf="overflowed" [attr.points]="topFace" class="overflow-warn" />

  <!-- pour stream -->
  <path *ngIf="isPouring" class="stream"
        [attr.d]="'M ' + (GX - 4) + ' ' + (GY_BOT - 6) + ' Q ' + (tankCenter.x + 40) + ' ' + (OY - tankH - 40) + ' ' + tankCenter.x + ' ' + (OY - tankH + 8)" />

  <!-- ── Measuring test-tube ───────────────────────────────────────── -->
  <g class="gauge">
    <!-- glass tube -->
    <rect class="gauge-glass" [attr.x]="GX" [attr.y]="GY_TOP - 14" [attr.width]="GW" [attr.height]="(GY_BOT - GY_TOP) + 28" [attr.rx]="GW / 2" />
    <!-- glowing liquid (clipped to tube) + rising bubbles -->
    <g clip-path="url(#cf-gtube-clip)">
      <rect class="gauge-liq" [attr.x]="GX" [attr.y]="gaugeLevelY" [attr.width]="GW" [attr.height]="(GY_BOT + 16) - gaugeLevelY" />
      <g clip-path="url(#cf-gliq-clip)">
        <circle class="gb" *ngFor="let b of gaugeBubbles" [attr.cx]="b.x" [attr.cy]="GY_BOT - 6" [attr.r]="b.r"
                [style.animation-delay.ms]="b.delay" [style.animation-duration.ms]="b.dur" />
      </g>
    </g>
    <!-- bright surface -->
    <ellipse *ngIf="n > 0" class="gauge-meniscus" [attr.cx]="GX + GW / 2" [attr.cy]="gaugeLevelY" [attr.rx]="GW / 2 - 2" ry="7" />
    <!-- glass shine -->
    <rect class="gauge-shine" [attr.x]="GX + 10" [attr.y]="GY_TOP - 2" width="8" [attr.height]="(GY_BOT - GY_TOP) - 8" rx="4" />
    <!-- ticks -->
    <g *ngFor="let t of gaugeTicks">
      <line class="gtick" [attr.x1]="GX - 11" [attr.y1]="levelY(t)" [attr.x2]="GX - 3" [attr.y2]="levelY(t)" />
      <text class="gnum" [attr.x]="GX - 17" [attr.y]="levelY(t) + 6" text-anchor="end">{{ t }}</text>
    </g>
    <!-- glowing handle orb -->
    <g class="handle" [attr.transform]="'translate(' + (GX + GW) + ',' + gaugeLevelY + ')'">
      <circle class="handle-glow" r="21" />
      <circle class="handle-orb" r="13" fill="url(#cf-orb)" />
      <path class="handle-grip-lines" d="M -5 -3.5 h 10 M -5 0 h 10 M -5 3.5 h 10" />
    </g>
    <!-- readout -->
    <text class="gauge-read" [attr.x]="GX + GW / 2" [attr.y]="GY_TOP - 32" text-anchor="middle">{{ n }}</text>
    <text class="gauge-unit" [attr.x]="GX + GW / 2" [attr.y]="GY_BOT + 42" text-anchor="middle">{{ currLang === 'ar' ? 'وحدة مكعبة' : 'cubic units' }}</text>
  </g>

  <!-- gauge drag surface -->
  <rect class="gauge-drag" [attr.x]="GX - 90" [attr.y]="GY_TOP - 24" [attr.width]="GW + 130" [attr.height]="(GY_BOT - GY_TOP) + 60"
        fill="transparent" (pointerdown)="onDown($event)" />
</svg>
